import { createFileRoute, redirectUnauthenticated } from '@frontend/web/utils/router';
import { handleOnboardingCompleteBeforeLoad } from '@frontend/web/utils/routing/handleRedirectBeforeLoad';
import { validateSignUpSearch } from '../-publicSearch';

export const Route = createFileRoute('/onboarding/profile')({
  beforeLoad: async ({ context, location }) => {
    redirectUnauthenticated({ context, location });
    handleOnboardingCompleteBeforeLoad({ context, location });
  },
  validateSearch: validateSignUpSearch,
});
